(function(){
  var ENDPOINT="https://api.shilajit.work/api/meta/atc-shadow";
  var PIXEL_ID="1132329752058712";
  var ANON_KEY="_hng_meta_anon_id";
  var ANON_TS_KEY="_hng_meta_anon_id_ts";
  var ANON_TTL_MS=90*24*60*60*1000;
  function cookie(name){
    try{
      var parts=("; "+document.cookie).split("; "+name+"=");
      return parts.length===2?decodeURIComponent(parts.pop().split(";").shift()):"";
    }catch(e){return ""}
  }
  function looksLikeFbc(value){
    return /^fb\.1\.\d+\.[^\s.][^\s]*$/.test(String(value||""));
  }
  function looksLikeFbp(value){
    return /^fb\.1\.\d+\.\d+$/.test(String(value||""));
  }
  function looksLikeHngAnon(value){
    return /^hnganon_[a-f0-9]{32}$/.test(String(value||""));
  }
  function randomHex32(){
    var bytes=[];
    try{
      if(window.crypto&&window.crypto.getRandomValues){
        var arr=new Uint8Array(16);
        window.crypto.getRandomValues(arr);
        for(var i=0;i<arr.length;i+=1)bytes.push(arr[i]);
      }
    }catch(e){}
    while(bytes.length<16)bytes.push(Math.floor(Math.random()*256));
    return bytes.map(function(b){return ("0"+b.toString(16)).slice(-2)}).join("");
  }
  function readAttributionData(){
    try{
      var stored=window.localStorage&&window.localStorage.getItem("_attribution_data");
      if(stored)return JSON.parse(stored);
    }catch(e){}
    try{
      var raw=cookie("_attribution_data");
      if(raw)return JSON.parse(raw);
    }catch(e){}
    return {};
  }
  function rawParam(name){
    try{
      var search=window.location&&window.location.search?window.location.search:"";
      var re=new RegExp("(?:^|[?&])"+name+"=([^&]+)");
      var match=search.match(re);
      return match?match[1]:"";
    }catch(e){return ""}
  }
  function validRawFbclid(value){
    return /^[^\s.][^\s]*$/.test(String(value||""));
  }
  function normalizeFbc(value){
    if(!looksLikeFbc(value))return "";
    var clean=String(value).trim();
    var parts=clean.split(".");
    var ts=Number(parts[2]);
    if(!ts||ts<1500000000)return "";
    if(ts<1000000000000){
      parts[2]=String(Math.floor(ts*1000));
      return parts.join(".");
    }
    return clean;
  }
  function metaFbc(data,eventTime){
    var direct=cookie("_fbc")||(data&&data.fbc);
    var normalized=normalizeFbc(direct);
    if(normalized)return normalized;
    var fbclid=rawParam("fbclid")||(data&&data.fbclid)||"";
    if(!validRawFbclid(fbclid))return "";
    var ts=Number(data&&data.captured_at);
    if(!ts||ts<1500000000)return "";
    if(ts<1000000000000)ts=ts*1000;
    return "fb.1."+Math.floor(ts)+"."+fbclid;
  }
  function metaFbp(data){
    var direct=cookie("_fbp")||(data&&data.fbp);
    return looksLikeFbp(direct)?String(direct).trim():"";
  }
  function privacyAllowed(){
    try{
      var privacy=window.Shopify&&window.Shopify.customerPrivacy;
      if(privacy&&typeof privacy.analyticsProcessingAllowed==="function"&&typeof privacy.marketingAllowed==="function"){
        return privacy.analyticsProcessingAllowed()||privacy.marketingAllowed();
      }
    }catch(e){}
    return true;
  }
  function metaAnonId(){
    if(!privacyAllowed())return "";
    try{
      var now=Date.now();
      var stored=window.localStorage&&window.localStorage.getItem(ANON_KEY);
      var storedAt=Number(window.localStorage&&window.localStorage.getItem(ANON_TS_KEY));
      if(looksLikeHngAnon(stored)&&storedAt&&now-storedAt<ANON_TTL_MS)return stored;
      var fresh="hnganon_"+randomHex32();
      if(!looksLikeHngAnon(fresh))return "";
      if(window.localStorage){
        window.localStorage.setItem(ANON_KEY,fresh);
        window.localStorage.setItem(ANON_TS_KEY,String(now));
      }
      return fresh;
    }catch(e){return ""}
  }
  function shadow(payload){
    try{
      if(!privacyAllowed())return;
      var attribution=readAttributionData();
      payload.event_time=payload.event_time||Math.floor(Date.now()/1000);
      payload.fbp=metaFbp(attribution);
      payload.fbc=metaFbc(attribution,payload.event_time);
      var anonId=metaAnonId();
      if(anonId)payload.external_id_raw=anonId;
      payload.event_source_url=window.location&&window.location.href?window.location.href:"https://naturalshilajit.com/";
      var body=JSON.stringify(payload);
      if(navigator.sendBeacon){
        var blob=new Blob([body],{type:"text/plain;charset=UTF-8"});
        if(navigator.sendBeacon(ENDPOINT,blob))return;
      }
      if(window.fetch){
        fetch(ENDPOINT,{method:"POST",mode:"cors",credentials:"omit",keepalive:true,headers:{"Content-Type":"text/plain;charset=UTF-8"},body:body}).catch(function(){});
      }
    }catch(e){}
  }
  window.NSMetaTrackAddToCart=function(form,button){
    try{
      var now=Date.now();
      if(form&&form.__nsMetaAtcLast&&now-form.__nsMetaAtcLast<1500)return;
      if(form)form.__nsMetaAtcLast=now;
      if(!form||form.classList&&(" "+form.className+" ").match(/\s(free-product-form|shipping-protection-form)\s/))return;
      if(!privacyAllowed())return;
      var fd=new FormData(form),variantId=fd.get("ns_meta_variant_id")||fd.get("id")||"",quantity=Number(fd.get("quantity")||form.getAttribute("data-quantity")||1)||1;
      if(!variantId||variantId==="0"){
        for(var pair of fd.entries()){
          if(/^items\[\d+\]\[id\]$/.test(pair[0])&&pair[1]&&pair[1]!=="0"){
            variantId=String(pair[1]);
            var qName=pair[0].replace("[id]","[quantity]");
            quantity=Number(fd.get(qName)||quantity)||quantity;
            break;
          }
        }
      }
      var cents=Number(fd.get("ns_meta_variant_price_cents")||0),unitPrice=cents>0?Number((cents/100).toFixed(2)):0;
      if(!unitPrice&&button){
        var text=(button.innerText||button.textContent||"").replace(/,/g,"");
        var priceMatch=text.match(/\$\s*([0-9]+(?:\.[0-9]{1,2})?)/);
        if(priceMatch)unitPrice=Number(priceMatch[1])||0;
      }
      if(!variantId||variantId==="0"||unitPrice<=0)return;
      var currency=String(fd.get("ns_meta_currency")||"USD");
      var value=Number((unitPrice*quantity).toFixed(2));
      var eventID="ns-theme-atc-"+Date.now()+"-"+String(variantId);
      if(typeof window.fbq!=="function"||!window.fbq.loaded||!window.fbq.version){
        window.__nsMetaPrevFbq=window.fbq;
        window.fbq=void 0;
        window._fbq=void 0;
        !function(f,b,e,v,n,t,s){n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,"script","https://connect.facebook.net/en_US/fbevents.js");
      }
      if(!window.__nsMetaAtcInit){
        fbq("init",PIXEL_ID);
        window.__nsMetaAtcInit=true;
      }
      fbq("track","AddToCart",{value:value,currency:currency,content_ids:[String(variantId)],content_type:"product",contents:[{id:String(variantId),quantity:quantity,item_price:unitPrice}]},{eventID:eventID});
      shadow({event_name:"AddToCart",event_id:eventID,event_time:Math.floor(Date.now()/1000),variant_id:String(variantId),quantity:quantity,item_price:unitPrice,value:value,currency:currency});
    }catch(e){console.warn("NS Meta AddToCart skipped",e&&e.message?e.message:e)}
  };
  if(!window.NSMetaTrackAddToCartClickBound){
    window.NSMetaTrackAddToCartClickBound=true;
    document.addEventListener("click",function(e){
      if(!e.target||!e.target.closest)return;
      var target=e.target.closest('button[type="submit"],button[name="add"],button:not([type])');
      var form=target&&target.closest?target.closest('form[action*="/cart/add"]'):null;
      if(form&&(form.classList.contains("free-product-form")||form.classList.contains("shipping-protection-form")))return;
      if(target&&form&&window.NSMetaTrackAddToCart)window.NSMetaTrackAddToCart(form,target);
    },true);
  }
})();
